var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3, _circle4, _rect2, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPreview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 380,
    viewBox: "0 0 800 380",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 800,
    y2: 380,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E314D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A90C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "route",
    x1: 180,
    y1: 80,
    x2: 622,
    y2: 280,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B35"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 380,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 42H214V132H36V42Z",
    fill: "#3E92B9",
    fillOpacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 46H454V116H256V46Z",
    fill: "#5DA9C7",
    fillOpacity: 0.38
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M560 30H764V104H560V30Z",
    fill: "#6CB7D0",
    fillOpacity: 0.34
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64 196H242V340H64V196Z",
    fill: "#2D7BA2",
    fillOpacity: 0.38
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M292 182H514V336H292V182Z",
    fill: "#4F9AB9",
    fillOpacity: 0.34
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M568 168H760V340H568V168Z",
    fill: "#71B6CD",
    fillOpacity: 0.28
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158 276C206 252 278 242 340 202C402 162 448 114 506 106C564 98 612 118 654 154",
    stroke: "url(#route)",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 276,
    r: 12,
    fill: "#F3F7FB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 276,
    r: 6,
    fill: "#FF6B35"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 654,
    cy: 154,
    r: 12,
    fill: "#F3F7FB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 654,
    cy: 154,
    r: 6,
    fill: "#F7C948"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 292,
    width: 230,
    height: 58,
    rx: 10,
    fill: "#F3F7FB",
    fillOpacity: 0.17
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50 321H226",
    stroke: "#E2EEF8",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPreview);
export default __webpack_public_path__ + "static/media/map-preview.d151e91e9c21796ceacc52d4f1fa1cac.svg";
export { ForwardRef as ReactComponent };